import SimpleSelect from '@components/V3/forms/SimpleSelect'
import dayjs from 'dayjs'
import range from 'lodash/range'

import {ReservationLabel} from '../../Label'
import {useCreateReservationContext} from '../../ReservationContext'

export default function SelectDay() {
  const {storeOptions, dateDay, setDateDay} = useCreateReservationContext()
  return (
    <div>
      <ReservationLabel>Selecciona el día</ReservationLabel>
      <SimpleSelect
        options={range(storeOptions.reservationsOpenBeforeDays).map(addDays => ({
          label: dayjs()
            .startOf('day')
            .add(addDays, 'day')
            .tz(storeOptions.timezone)
            .format(
              {
                0: '[Hoy]',
                1: '[Mañana] DD [de] MMMM',
              }[addDays] || 'dddd DD [de] MMMM',
            ),
          value: dayjs().startOf('day').add(addDays, 'day').tz(storeOptions.timezone).format(),
        }))}
        value={dayjs(dateDay).tz(storeOptions.timezone).format()}
        onChange={(dateString: string) =>
          setDateDay(dayjs(dateString).tz(storeOptions.timezone).toDate())
        }
      />
    </div>
  )
}
